import React from "react"
import { FlexBox } from "ui/components/FlexBox"

interface ICampaignSummaryColumnProps {
  contentWidth: number
  twoColumns?: boolean
  sx?: any
}

export class CampaignSummaryColumn extends React.PureComponent<ICampaignSummaryColumnProps, {}> {
  public render() {
    const { children, twoColumns, contentWidth, sx } = this.props
    return contentWidth < 530 || !twoColumns ? (
      <FlexBox vertical ai="start" jc="start" fullWidth gap sx={{ p: "1rem", pl: "1.5rem", pr: "1.5rem", ...sx }}>
        {children}
      </FlexBox>
    ) : (
      <FlexBox
        jc="start"
        ai="start"
        gap
        fullWidth
        wrap
        sx={{
          "p": "1rem",
          "pl": "1.5rem",
          "pr": "1.5rem",
          "& > *": { width: "calc(50% - 1rem)" },
          ...sx
        }}>
        {children}
      </FlexBox>
    )
  }
}
